export default "__VITE_ASSET__BTOF8uBQ__"